/*

Wraps containers in a `div` and supplies children with css-transition-group 
classes. Use these classes to animate component enter and exit using css, 
for example:

.on-enter {
	opacity: 0.01;
}

.on-enter-active {
	opacity: 1;
	transition: opacity 500ms ease-in;
}

.on-leave {
	opacity: 1;
}

.on-leave-active {
	opacity: 0.01;
	transition: opacity 300ms ease-in;
}

*/

import React, { Component } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

export default class Animator extends Component {
	render() {
		const { children, location } = this.props;
		const key = location.pathname || "";
		return (
			<ReactCSSTransitionGroup
				component="div"
				style={{
					position: "relative",
					width: "100%",
					height: "100%",
				}}
				transitionName="on"
				transitionEnterTimeout={1000}
				transitionLeaveTimeout={1000}>
				
				{React.cloneElement(children, {key})}
			
			</ReactCSSTransitionGroup>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Animator.js